import {WriteButton} from '../../common/buttons/WriteActions';
import {Alert, Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField, Typography,} from "@mui/material";
import {useState} from "react";
import {useAppTranslation} from "@mybake/ui/hooks/useAppTranslation";
import TraceIdFeedback from '../../feedback/TraceIdFeedback';

interface Props {
    open: boolean;
    onClose: () => void;
    decorationName: string;
    onDelete: () => Promise<boolean>;
    error?: string;
    traceId?: string;
}

export const DeleteDecorationDialog = ({
                                           open,
                                           onClose,
                                           decorationName,
                                           onDelete,
                                           error,
                                           traceId,
                                       }: Props) => {
    const {t} = useAppTranslation();
    const [confirmationText, setConfirmationText] = useState("");
    const [deleting, setDeleting] = useState(false);

    const isValid =
        confirmationText.trim() === decorationName.trim();

    const handleClose = () => {
        setConfirmationText("");
        onClose();
    };

    const handleDelete = async () => {
        setDeleting(true);
        try {
            if (await onDelete()) handleClose();
        } finally {
            setDeleting(false);
        }
    };

    return (
        <Dialog open={open} onClose={handleClose}>
            <DialogTitle>{t('recipes:delete_decoration')}</DialogTitle>

            <DialogContent>
                <Typography sx={{mb: 2}}>
                    {t('recipes:delete_decoration_confirmation')}
                </Typography>

                <Typography
                    color="error"
                    fontWeight={600}
                    sx={{mb: 2}}
                >
                    {decorationName}
                </Typography>

                <TextField
                    fullWidth
                    label={t('recipes:decoration_name')}
                    value={confirmationText}
                    onChange={(e) =>
                        setConfirmationText(e.target.value)
                    }
                />
                {error && <Alert severity="error" sx={{mt: 2}}>{error}<TraceIdFeedback traceId={traceId}/></Alert>}
            </DialogContent>

            <DialogActions>
                <Button onClick={handleClose}>
                    {t('common:cancel')}
                </Button>

                <WriteButton
                    color="error"
                    variant="contained"
                    disabled={!isValid || deleting}
                    onClick={handleDelete}
                >
                    {t('common:delete')}
                </WriteButton>
            </DialogActions>
        </Dialog>
    );
};
